<div>
  <table class="table table-responsive-md text-left">
    <thead>
    <tr>
      <th>{{ 'paymentRequestInformation.financialTransactions.financialTransactionIdFieldLabel' | translate }}</th>
      <th>{{ 'paymentRequestInformation.financialTransactions.createdAtFieldLabel' | translate }}</th>
      <th>{{ 'paymentRequestInformation.financialTransactions.amountFieldLabel' | translate }}</th>
      <th>{{ 'paymentRequestInformation.financialTransactions.creditAmountAfterFieldLabel' | translate }}</th>
    </tr>
    </thead>
    <tbody>
    <tr *ngFor="let financialTransaction of financialTransactions">
      <td>{{ financialTransaction.FinancialTransactionId }}</td>
      <td>{{ financialTransaction.CreatedAt | date:'d-M-y HH:mm:ss' }}</td>
      <td>{{ financialTransaction.AmountCurrency }}</td>
      <td>{{ financialTransaction.CreditAmountAfterCurrency }}</td>
    </tr>
    </tbody>
  </table>
</div>
